// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-feature-tag-newFeatureTag-4df7a{background-color:var(--RED_1);border-radius:2px;color:var(--GRAY_11);display:inline-block;height:16px;line-height:16px;margin-left:8px;text-align:center;vertical-align:middle;width:38px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newFeatureTag": "new-feature-tag-newFeatureTag-4df7a"
};
export default ___CSS_LOADER_EXPORT___;
